import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import MultiLayerFilter from '@features/filter/Common/MultiLayerFilter';
import { allFilterPages } from '@features/filter/static/filterUtil';

const FabricTypeV2 = ({ filterPageName }) => {
	const [filterOptions, setFilterOptions] = useState([]);
	const [allOptions, setAllOptions] = useState([]);
	const selectedField = useSelector((store) => store.slectedCheckBoxFieldStore);
	const { dependentFilterList } = useSelector((store) => store.dependentFilterListStore);
	const [selectedMultilevelData, setSelectedMultiLevelData] = useState([]);
	const multiLevelFilterStore = useSelector((store) => store.multiLevelFIlterStore);
	const currentSelectedFilterLevel = multiLevelFilterStore?.currentSelectedFilterLevel;

	useEffect(() => {
		onFetchFabricTypeV2Data();
	}, [dependentFilterList]);

	useEffect(() => {
		setSelectedMultiLevelData(multiLevelFilterStore?.multiLevelFilters);
	}, [multiLevelFilterStore]);

	useEffect(() => {
		setFilterOptions(allOptions);
	}, [selectedField]);

	const filterData = {
		[allFilterPages.FABRIC_LIST_TAB]: dependentFilterList?.fabricTypeList,
		[allFilterPages.PRODUCT_LIST]: dependentFilterList?.fabricTypeList,
		[allFilterPages.COSTING_LIST]: dependentFilterList?.fabricTypeList,
		[allFilterPages.FAVOURITE_DETAILS]: dependentFilterList?.fabricTypeList,
		[allFilterPages.COLLECTION_DETAILS]: dependentFilterList?.fabricTypeList,
		[allFilterPages.MY_ORDER]: dependentFilterList?.fabricTypeList
	};

	const onFetchFabricTypeV2Data = async () => {
		let responseData = filterData[filterPageName];

		responseData = responseData?.map((item) => {
			const { count, name, fabricConstructionGroupList, constant } = item;

			const validGroupList = Array.isArray(fabricConstructionGroupList)
				? fabricConstructionGroupList
				: [];
			const subCategoryList = validGroupList?.map((secondLayerItem) => {
				const constructionList = secondLayerItem?.constructionList.map((thirdLayerItem) => ({
					...thirdLayerItem,
					categoryId: secondLayerItem?.id,
					id: thirdLayerItem?.id,
					label: 4
				}));
				return {
					...secondLayerItem,
					id: secondLayerItem?.id,
					label: 3,
					subCategory: [
						{
							name: 'All',
							id: `ALL`,
							count: secondLayerItem?.count,
							categoryId: secondLayerItem?.id
						},
						...constructionList
					]
				};
			});

			const labelThreeCategories = [
				{ name: 'All', id: `ALL`, count, categoryId: constant },
				...validGroupList.flatMap(({ id: secondLayerId, constructionList }) =>
					constructionList.map(({ id: thirdLayerId, ...thirdLayerProps }) => ({
						...thirdLayerProps,
						id: thirdLayerId,
						categoryId: secondLayerId,
						label: 4
					}))
				)
			];

			const labelThree = {
				name: `All ${name}`,
				id: `${constant}-ALL`,
				count,
				categoryId: constant,
				label: 3,
				subCategory: labelThreeCategories
			};

			return {
				count,
				name,
				id: constant,
				label: 2,
				subCategory: [labelThree, ...subCategoryList]
			};
		});
		setAllOptions(responseData);
		setFilterOptions(responseData);
	};

	return (
		<>
			<MultiLayerFilter
				filterOptions={filterOptions}
				selectedField={selectedField}
				selectedMultilevelData={selectedMultilevelData}
				allOptions={allOptions}
				setFilterOptions={setFilterOptions}
				currentSelectedFilterLevel={currentSelectedFilterLevel}
				type="FABRIC_TYPE_V2"
				isOpenFourthLayerOnSearch={true}
			/>
		</>
	);
};

export default FabricTypeV2;
